import { Platform } from './Platform';
const DesktopMessaging = new Map([]);
const MobileMessaging = new Map([]);
export const MessageOverideConfig = {
  [Platform.Desktop]: DesktopMessaging,
  [Platform.Mobile]: MobileMessaging
};